// extracted by mini-css-extract-plugin
export var container = "_fs-1";
export var editor = "_fs-2";
export var resizable = "_fs-3";
export var wrapper = "_fs-0";